export default "__VITE_ASSET__DcQrIY2n__"